import React from 'react';
import { useSession } from '../context/SessionContext';
import { WifiOff, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';
import { useTranslation } from "react-i18next";

export const BackendStatusOverlay: React.FC = () => {
  const { t } = useTranslation();
  const { isBackendOnline, recheckBackend } = useSession();
  const [isRechecking, setIsRechecking] = React.useState(false);

  const handleRecheck = async () => {
    setIsRechecking(true);
    await recheckBackend();
    setTimeout(() => setIsRechecking(false), 1000);
  };

  if (isBackendOnline) {
    return null;
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9998]" />
      
      <div className="fixed inset-0 flex items-center justify-center z-[9999] pointer-events-none">
        <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md mx-4 pointer-events-auto">
          <div className="flex flex-col items-center text-center space-y-6">
            <div className="relative">
              <div className="absolute inset-0 bg-red-100 rounded-full animate-ping opacity-75" />
              <div className="relative bg-red-50 p-4 rounded-full">
                <WifiOff className="w-12 h-12 text-red-500" />
              </div>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl font-bold text-gray-900">
                {t("connection_lost")}
              </h2>
              <p className="text-gray-600">
                {t("connection_lost_description")}
              </p>
            </div>

            <div className="w-full bg-gray-50 rounded-lg p-4 space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-500">{t("server_status")}</span>
                <span className="font-medium text-red-600">{t("disconnected")}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-500">{t("retrying")}</span>
                <span className="font-medium text-gray-700">{t("automatically")}</span>
              </div>
            </div>

            <Button
              onClick={handleRecheck}
              disabled={isRechecking}
              className="w-full bg-[#105BDB] hover:bg-[#0055C4] text-white font-medium py-3 rounded-lg transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
            >
              {isRechecking ? (
                <>
                  <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                  {t("checking")}
                </>
              ) : (
                t("retry_connection")
              )}
            </Button>

            <p className="text-xs text-gray-500">
              {t("auto_reconnect_message")}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
